/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { darken, mix } from 'polished';
import Mixin from '../../../util/mixin';


export class BgVariant extends Mixin {
  style({}, [parent, color]) {
    return css`
      ${parent} {
        background-color: ${color} !important;
      }

      a${parent},
      button${parent} {
        &:hover,
        &:focus {
          background-color: ${darken(0.1, color)} !important;
        }
      }
    `;
  }
}

export class BgGradientVariant extends Mixin {
  style({$}, [parent, color]) {
    return css`
      ${parent} {
        background: ${color} linear-gradient(
          180deg,
          ${mix(0.15, $.bodyBg, color)},
          ${color}
        ) repeat-x !important;
      }
    `;
  }
}